import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.createEcoTaxPage.title, 'Create ecotax'),
  ecoTax: () => __(translations.createEcoTaxPage.ecoTax, 'Ecotax'),
};
